import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";

const useStyles = makeStyles((theme) => ({
  header: {
    paddingTop: 0,
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

function TestimonialsSection(props) {
  const classes = useStyles();

  const items = [
    {
      avatar:
        "https://cdn.vox-cdn.com/thumbor/Zm0Zm6nzpgoeZvXxRIUijJJpiU0=/1400x1400/filters:format(jpeg)/cdn.vox-cdn.com/uploads/chorus_asset/file/22666447/1320718286.jpg",
      name: "Connor McDavid",
      testimonial:
        "Working with Ben [Velazquez] has been great. Being able to do it online allows for flexibility and the ability to get a session in anywhere, anytime. He has helped me recover from serious injuries and helped me prevent others from occurring.",
      company: "NHL Player",
    },
    {
      avatar:
        "http://nebula.wsimg.com/b0d3bdc617cdb94233a548382f7de4e4?AccessKeyId=9284AF244A6E0FC8850F&disposition=0&alloworigin=1",
      name: "Kevin McCarthy",
      testimonial:
        "The evaluation process was well guided and quick. I was able to learn about some of the different habits my body has fallen into and understand how I can help retrain my imbalances.",
      company: "Player Development Coach for the Toronto Blue Jays",
    },
    {
      avatar:
        "https://static.www.nfl.com/image/private/t_headshot_desktop/league/rmrohuw9tgfqlolewzvx",
      name: "Christian McCafrey",
      testimonial:
        "I’ve been working with Ben for a while now and since then, my career has changed for the better. The intricacies that are detailed constantly in his program will take you from good to great. It’s one of the best tools in my toolbox.",
      company: "NFL Player",
    },
  ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        <Grid container={true} justifyContent="center" spacing={4}>
          {items.map((item, index) => (
            <Grid item={true} xs={12} sm={4} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="body1" component="p">
                    "{item.testimonial}"
                  </Typography>
                </CardContent>
                <CardHeader
                  className={classes.header}
                  avatar={
                    <Avatar
                      src={item.avatar}
                      alt={item.name}
                      className={classes.avatar}
                    />
                  }
                  title={item.name}
                  subheader={item.company}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}

export default TestimonialsSection;
